import { render, staticRenderFns } from "./SubjectTeacherList.vue?vue&type=template&id=382fb2d6"
import script from "../../controllers/subject_teacher/subject_teacher-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/subject_teacher/subject_teacher-list.js?vue&type=script&lang=js&external"
import style0 from "./SubjectTeacherList.vue?vue&type=style&index=0&id=382fb2d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports